module.exports = "<li class=blog-listing__filter-collapsed-options> <a href=# class=blog-listing__filter-collapsed-options-label aria-label=\"More Categories\"><svg viewBox=\"0 0 100 100\"><use xlink:href=#elypsis></use></svg></a> <ul class=blog-listing__filter-collapsed-options-dropdown></ul> </li> ";


//////////////////
// WEBPACK FOOTER
// ./src/ktu/js/templates/blogs/blog-listing-filter-collapsed.html
// module id = 675
// module chunks = 1